import { useProjectUserRoles } from '@contember/react-identity'
import type { ReactNode } from 'react'
import { adminConfig } from '~/entrypoint/config'

const ADMIN_ROLE = 'admin'

/**
 * Renders `children` only for the `admin` project role (decision 25 role
 * taxonomy). In local dev there is no login gate and the root token carries
 * no identity, so everything is admin. Split into two components because
 * `useProjectUserRoles` needs the `IdentityProvider` that only the prod
 * layout mounts.
 */
export function AdminOnly({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
	if (!adminConfig.requireLogin) return <>{children}</>
	return <AdminGate fallback={fallback}>{children}</AdminGate>
}

function AdminGate({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
	const roles = useProjectUserRoles()
	if (roles.has(ADMIN_ROLE)) return <>{children}</>
	return (
		<>
			{fallback ?? (
				<p className="rounded-md border border-warning/30 bg-warning-bg px-4 py-3 text-sm text-warning">
					This page is for administrators only.
				</p>
			)}
		</>
	)
}
